/* eslint-disable indent */
import React, { useContext, useEffect, useState } from "react";
import Comment from "components/molecules/Comment";
import { DeleteConfirmationModal } from "components/molecules/DeleteModal";
import ReplySection from "components/molecules/ReplySection";
import { deleteComment, getCommentsByImage } from "lib/actions";
import { AppContext } from "lib/contexts";
import { AppReducerActionType, ICommentDTO, ImageDTO } from "types";
import { Span, Text } from "utils/styling/typography.styled";
import * as Styled from "./CommentSection.styled";
interface CommentsSectionProps {
  image: ImageDTO | null;
  initialComments: ICommentDTO[];
}
const CommentsSection: React.FC<CommentsSectionProps> = ({
  image,
  initialComments
}) => {
  const {
    state,
    dispatch
  } = useContext(AppContext);
  const [comments, setComments] = useState<ICommentDTO[]>(initialComments);
  const [sortOrder, setSortOrder] = useState<string>("top");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState<string | null>(null);
  useEffect(() => {
    if (image) {
      const fetchComments = async () => {
        const response = await getCommentsByImage(image.id, sortOrder);
        if (response.comments) {
          setComments(response.comments);
        } else if (response.error) {
          console.error("Failed to fetch comments:", response.error);
        }
      };
      fetchComments();
    }
  }, [image, sortOrder]);
  const prepareForDelete = (commentId: string) => {
    setCommentToDelete(commentId);
    setShowDeleteConfirmation(true);
  };
  const handleConfirmDelete = async () => {
    if (!commentToDelete) return;
    try {
      await deleteComment(commentToDelete);
      handleDeleteComment(commentToDelete);
      setShowDeleteConfirmation(false);
      setCommentToDelete(null);
    } catch (error) {
      console.error("Failed to delete comment:", error);
      setShowDeleteConfirmation(false);
      setCommentToDelete(null);
    }
  };
  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
    setCommentToDelete(null);
    dispatch({
      type: AppReducerActionType.TOGGLE_OVERLAY_VISIBILITY,
      payload: {
        ...state,
        isOverlayVisible: false
      }
    });
  };
  const handleNewComment = (newComment: ICommentDTO) => {
    setComments(prevComments => [newComment, ...prevComments]);
  };
  const handleDeleteComment = (commentId: string) => {
    setComments(prevComments => prevComments.filter(comment => comment.id !== commentId));
  };
  const sortingOptions = ["newest", "oldest", "top"];
  return <Styled.CommentsContainer data-sentry-element="unknown" data-sentry-component="CommentsSection" data-sentry-source-file="index.tsx">
            <Styled.HeaderContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">Comments</Text>
                <Styled.SortingContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Popover data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        <Styled.PopoverButton data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Sort</Span>
                        </Styled.PopoverButton>
                        <Styled.PopoverPanel data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <Styled.PopoverContent data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                {sortingOptions.map(option => <Styled.SortingOption key={option} onClick={() => setSortOrder(option)} className={sortOrder === option ? "active" : ""}>
                                        {option}
                                    </Styled.SortingOption>)}
                            </Styled.PopoverContent>
                        </Styled.PopoverPanel>
                    </Styled.Popover>
                </Styled.SortingContainer>
            </Styled.HeaderContainer>
            <ReplySection parentId={undefined} imageId={image?.id || ""} onNewComment={handleNewComment} data-sentry-element="ReplySection" data-sentry-source-file="index.tsx" />
            {comments.map(comment => <Comment key={comment.id} comment={comment} image={image || null} onDelete={prepareForDelete} nestingLevel={0} />)}
            <DeleteConfirmationModal isOpen={showDeleteConfirmation} onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} text="comment" data-sentry-element="DeleteConfirmationModal" data-sentry-source-file="index.tsx" />
        </Styled.CommentsContainer>;
};
export default CommentsSection;